<script setup lang="ts">
import UserMenuItems from '@/components/user/header/UserMenuItems.vue';
import Breadcrumbs from '@/components/base/Breadcrumbs.vue';
</script>

<template>
  <Breadcrumbs />
  <UserMenuItems class="mx-auto" />
</template>
